import React, { useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from "@mui/material";
import Paper from "@mui/material/Paper";

import { useFetchGetV2 } from "hooks/fetch/useFetchGetV2";
// import { useFetchPutV2 } from "hooks/fetch/useFetchPutV2";
// import { Autocomplete } from "components/Autocomplete";
import { Breadcrumbs } from "components/Breadcrumbs";

import { AppTitleContext } from "app_context";
import { useRouteMatch } from "react-router";
import { useLoadCounter } from "hooks/useLoadCounter";

export const UserPage = () => {
  const match = useRouteMatch();
  const appTitleContext = useContext(AppTitleContext);

  const userId = match.params.id;
  const { loading, error, response } = useFetchGetV2(
    `settings/user_profile/${userId}`
  );
  const tableLoadCount = useLoadCounter(loading);

  useEffect(() => {
    appTitleContext.setPageTitle(
      <Breadcrumbs>
        <Link to={`/pages/settings`}>Settings</Link>
        {response && <span>User: {response?.email}</span>}
      </Breadcrumbs>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [response]);

  if (loading || error || !response) {
    return <></>;
  }

  return (
    <>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell data-col={1}>Property</TableCell>
              <TableCell data-col={2}>Value</TableCell>
            </TableRow>
          </TableHead>
          <TableBody
            data-qa_loading={loading}
            data-qa_load_count={tableLoadCount}
          >
            <TableRow>
              <TableCell data-col={1}>First Name</TableCell>
              <TableCell data-col={2}>{response?.first_name}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell data-col={1}>Last Name</TableCell>
              <TableCell data-col={2}>{response?.last_name}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell data-col={1}>E-mail</TableCell>
              <TableCell data-col={2}>{response?.email}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell data-col={1}>Username</TableCell>
              <TableCell data-col={2}>{response?.username}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell data-col={1}>Roles (Member)</TableCell>
              <TableCell data-col={2}>
                {response?.roles?.member?.map(role => {
                  return (
                    <p key={`role_${role.id}`}>
                      <Link to={`/pages/settings/role/${role.id}`}>
                        {role.name}
                      </Link>
                    </p>
                  );
                })}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell data-col={1}>Roles (Owner)</TableCell>
              <TableCell data-col={2}>
                {response?.roles?.owner?.map(role => {
                  return (
                    <p>
                      <Link to={`/pages/settings/role/${role.id}`}>
                        {role.name}
                      </Link>
                    </p>
                  );
                })}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell data-col={1}>Entitlements</TableCell>
              <TableCell data-col={2}>
                {response?.entitlements?.map(entitlement => {
                  return (
                    <p>
                      <Link
                        to={`/pages/settings/entitlement/${entitlement.id}`}
                      >
                        {entitlement.name}
                      </Link>
                    </p>
                  );
                })}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};
